import { render } from "./WebDevAggressive.vue?vue&type=template&id=0d8628de"
import script from "./WebDevAggressive.vue?vue&type=script&lang=js"
export * from "./WebDevAggressive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__